import { palettes } from './palettes';
import { colorPaletteKey, displayDensityKey, displayDensityKeys, displayDensity } from '../common/constants';

import { createTheme } from '@mui/material';

const getColorPalette = () => {
  let colorPalette = localStorage.getItem(colorPaletteKey);
  if (palettes[colorPalette])
    return palettes[colorPalette];
  else
    return palettes.grey;
}

const colorPalette = getColorPalette();

const getDisplayDensity = () => {
  let displayDensitySelection = localStorage.getItem(displayDensityKey);
  if (displayDensitySelection !== null) {
    let selectedDisplayDensity = displayDensity.find(t => t.name === displayDensitySelection);
    if (selectedDisplayDensity) {
      return selectedDisplayDensity;
    }
  }

  return displayDensity.find(t => t.name === displayDensityKeys.Medium);
}

const displayDensityTheme = getDisplayDensity();

const theme = createTheme({
  palette: {
    primary: {
      main: colorPalette.primary,
      light: colorPalette.primaryLight,
      dark: colorPalette.primaryDark,
      contrastText: colorPalette.primaryText
    },
    secondary: {
      main: colorPalette.secondary,
      contrastText: colorPalette.secondaryText
    },
    success: {
      main: colorPalette.success,
    },
    error: {
      main: colorPalette.error,
    },
    warning: {
      main: colorPalette.warning,
    },
    background: {
      default: colorPalette.background,
    },
    progress: {
      root: colorPalette.progressRoot,
      bar: colorPalette.progressBar,
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: displayDensityTheme.fontSize,
    body1: {
      fontSize: displayDensityTheme.fontSize
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: displayDensityTheme.btnSize
      }
    },
    MuiFilledInput: {
      defaultProps: {
        margin: displayDensityTheme.margin,
      }
    },
    MuiFormControl: {
      defaultProps: {
        margin: 'none',
        variant: 'standard',
      },
      styleOverrides: {
        marginDense: {
          marginTop: 0,
          marginBottom: 0
        }
      }
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: 'dense',
      }
    },
    MuiIconButton: {
      defaultProps: {
        size: displayDensityTheme.size,
      }
    },
    MuiInputBase: {
      defaultProps: {
        margin: displayDensityTheme.margin,
      },
      styleOverrides: {
        input: {
          fontSize: displayDensityTheme.fontSize,
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        margin: 'dense',
      }
    },
    MuiListItem: {
      defaultProps: {
        dense: displayDensityTheme.dense
      },
      styleOverrides: {
        dense: {
          paddingTop: displayDensityTheme.fontSize / 2,
          paddingBottom: displayDensityTheme.fontSize / 2
        }
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        margin: displayDensityTheme.margin,
      }
    },
    MuiFab: {
      defaultProps: {
        size: displayDensityTheme.btnSize,
      }
    },
    MuiTable: {
      defaultProps: {
        size: displayDensityTheme.size,
      }
    },
    MuiTextField: {
      defaultProps: {
        margin: displayDensityTheme.margin,
        variant: 'standard',
      }
    },
    MuiToolbar: {
      defaultProps: {
        variant: displayDensityTheme.variant,
      }
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true
      },
      styleOverrides: {
        tooltip: {
          fontSize: displayDensityTheme.fontSize
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          fontSize: displayDensityTheme.fontSize
        }
      }
    }
  },
});

export default theme;